import React from "react";
import CategorieList from "../components/CategorieList";

const Accueil = () => {
  return (
    <div className="page_accueil">
      <CategorieList />
    </div>
  );
};

export default Accueil;
